import React from 'react';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';

const SingleColumnWideLayout = ({rendering}) => (
  <section className='single-col-wide'>
    <Placeholder name="jss-single-col-wide" rendering={ rendering }/>
  </section>
);

export default SingleColumnWideLayout;